import { propOr, reduce, compose, assoc } from 'ramda';

const SlugsByUUID = compose(
  reduce((acc, val) => {
    if (!val.uuid || !val.slug) return acc;
    return assoc(val.uuid, val.slug, acc)
  }, {}),
  propOr([], 'rels')
)

export { SlugsByUUID };
